import Service from "../../../../utils/api/service";
import TableLoading from "./../../../../components/share/table-loading";
import NoItem from "./../../../../components/share/table-no-item";
import { mapState } from "vuex";

export default {
  name: "ListSettings",
  data() {
    return {
      isFetching: true,
      isUpdating: false,
      isNoData: false,
      data: {
        settings: [],
      },
      update: {
        data: "",
        show: false,
        index: -1,
      },
      setOrderDay: [
        { id: 0, name: "Sunday", key: "SUNDAY" },
        { id: 1, name: "Monday", key: "MONDAY" },
        { id: 2, name: "Tuesday", key: "TUESDAY" },
        { id: 3, name: "Wednesday", key: "WEDNESDAY" },
        { id: 4, name: "Thursday", key: "THURSDAY" },
        { id: 5, name: "Friday", key: "FRIDAY" },
        { id: 6, name: "Saturday", key: "SATURDAY" },
      ],
      expectDeliverDayEnum: [
        { id: 0, name: "Sunday", key: "SUNDAY" },
        { id: 1, name: "Monday", key: "MONDAY" },
        { id: 2, name: "Tuesday", key: "TUESDAY" },
        { id: 3, name: "Wednesday", key: "WEDNESDAY" },
        { id: 4, name: "Thursday", key: "THURSDAY" },
        { id: 5, name: "Friday", key: "FRIDAY" },
        { id: 6, name: "Saturday", key: "SATURDAY" },
      ],
    };
  },
  components: {
    TableLoading,
    NoItem,
  },
  created() {
    this.getAllSpecialBlendSetting();
  },
  watch: {
    "$route.fullPath": function () {
      this.getAllSpecialBlendSetting();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getAllSpecialBlendSetting() {
      Service.getAllSpecialBlendSetting().then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getAllSpecialBlendSetting();
              }
            });
          } else if (response.statusCode == "403") {
            this.isFetching = false;
            this.isNoData = true;
            this.data.settings = [];
            this.$toasted.show(response.message);
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.isFetching = false;

          if (response.data.length > 0) {
            this.isNoData = false;
            this.data.settings = response.data;
          } else {
            this.data.settings = [];
            this.isNoData = true;
          }
        }
      });
    },

    displayFormUpdate(index) {
      var setting = this.data.settings[index];

      this.update.data = {
        setOrderDay: this.getEnumById(setting.setOrderDay, this.setOrderDay)
          .name,
        expectDeliverDay: setting.expectDeliverDay,
        numberOfPeriodWeek: setting.numberOfPeriodWeek,
        expectDeliverDayTime: setting.expectDeliverDayTime,
        id: setting.id,
      };
      this.update.show = true;
      this.update.index = index;
    },

    getEnumById(id, enumArray) {
      return enumArray.find((item) => item.id === id) || null;
    },

    confirmUpdate() {
      this.isUpdating = true;
      let id = this.update.data.id;
      let body = {
        expectDeliverDay: this.update.data.expectDeliverDay,
        // numberOfPeriodWeek: this.update.data.numberOfPeriodWeek,
        // expectDeliverDayTime: this.update.data.expectDeliverDayTime,
      };

      Service.updateSpecialBlendSetting(id, body).then((response) => {
        this.isUpdating = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.confirmUpdate();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.settings[this.update.index] = this.update.data;
          this.$toasted.show("Special Blend Setting has been updated.");
          this.getAllSpecialBlendSetting();
          this.closeModal();
        }
      });
    },

    closeModal() {
      this.update = {
        data: "",
        show: false,
        index: -1,
      };
    },
  },
};
